import NavigationItem from "./NavigationItem";
import NavigationItemCollection from "./NavigationItemCollection";

export default class NavigationItemContainer
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.diary-day-search-edibles-navigation`;

	getNavigationItemCollection()
	{
		return new NavigationItemCollection(Array.from(this.el.querySelectorAll(NavigationItem.selector())).map(el => {
			return new NavigationItem(el);
		}));
	}

	hide()
	{
		this.el.hidden = true;

		return this;
	}

	show()
	{
		this.el.hidden = false;

		return this;
	}

	setFromQueryResponse(response)
	{
		this.getNavigationItemCollection().setFromQueryResponse(response);
	}
}
